export default "__VITE_ASSET__DzgkqQkH__"